import React, { ReactNode, useEffect } from 'react';

import Sidebar from './components/Sidebar';

import { ProfileActions } from '../actions/profile/profile.actions';

import { useAppDispatch, useAuth } from '../hooks';

import './v3.scss';

// V3 layout shell.  Wraps every v3 route with the redesigned sidebar and a
// `<main>` column the page is rendered into.  The `data-v3` attribute scopes
// the v3 stylesheet so it does not leak into the rest of the app.
//
// Dispatches `loadProfile` on mount (mirroring the legacy AuthenticatedLayout)
// so that `useAuth().profile` is populated for downstream consumers — the
// Sidebar's footer name and the Dashboard's greeting both need it.

interface Props {
  children: ReactNode;
}

const Layout = ({ children }: Props) => {
  const dispatch = useAppDispatch();
  const { profile } = useAuth();

  useEffect(() => {
    if (!profile) dispatch(ProfileActions.loadProfile());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);

  return (
    <div data-v3="true" className="v3-app">
      <Sidebar profile={profile} />
      <div className="main">{children}</div>
    </div>
  );
};

export default Layout;
